module.exports = __webpack_public_path__ + "img/scan.78d300ed.png";